import CustomComponent from "../../components/customComponent";
import { withToast } from "../../App";
import hoistStatics from "hoist-non-react-statics";
import { withTranslation } from "react-i18next";
import { withRouter } from "../../components/withRouter";
import { BoaterLayout } from "../../components/Layouts";
import EMailIcon from "../../assets/img/icons/email-letter.svg";
import { FormInput } from "../../components/FormComponents";
import { StepNavigation } from "../../components/StepNavigation";
import { validateBoaterCode, validateEmail } from "../../helpers/validation";
import { withBoaterStorage } from "../../hooks/useBoaterStorage";
import CGUCheckbox from "../../components/CGUCheckbox";

class BoaterProcessStep2 extends CustomComponent {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            verification: {
                email: "",
                code: "",
            },
            emailIsValid: false,
            codeIsValid: false,
            displayCodeInput: false,
            acceptCGU: false,
            cguWarningTrigger: 0,
        };
    }

    checkEMailValidity = () => {
        this.setState({
            emailIsValid:
                validateEmail(this.state.verification.email.trim()) === null,
        });
    };

    checkCodeValidity = () => {
        this.setState({
            codeIsValid:
                validateBoaterCode(this.state.verification.code) === null,
        });
    };

    handleEMailDispatch = async (e, resend = false) => {
        e?.preventDefault();
        if (!this.state.emailIsValid) return;
        if (!this.state.acceptCGU) {
            this.setState((prevState) => ({
                cguWarningTrigger: prevState.cguWarningTrigger + 1,
            }));
            return;
        }
        this.setState({ isLoading: true });

        const { t, i18n, boaterStorage } = this.props;

        const url = "/email-verification/request";
        const body = JSON.stringify({
            email: this.state.verification.email.trim(),
            language: i18n.language,
            connector_id: boaterStorage.connectorId,
        });
        const data = await this.request(
            url,
            "POST",
            body,
            false,
            "/email-verification/csrf",
        );

        if (data?.status === "ok") {
            this.props.addToast(
                resend ? t("boater_email_resent") : t("boater_email_sent"),
                {
                    appearance: "success",
                    autoDismiss: true,
                    autoDismissTimeout: 10000,
                },
            );
            this.setState({
                displayCodeInput: true,
                verification: { email: data.email, code: "" },
            });
        }

        this.setState({ isLoading: false });
    };

    handleCodeVerif = async (e) => {
        e?.preventDefault();
        if (!this.state.codeIsValid) return;
        this.setState({ isLoading: true });

        const url = "/email-verification/verify";
        const body = JSON.stringify({
            email: this.state.verification.email.trim(),
            code: this.state.verification.code,
        });
        const data = await this.request(
            url,
            "POST",
            body,
            false,
            "/email-verification/csrf",
        );

        if (data?.status === "ok" && data.verified === true) {
            const { t } = this.props;
            this.props.addToast(t("boater_code_success"), {
                appearance: "success",
                autoDismiss: true,
                autoDismissTimeout: 10000,
            });
            this.props.updateBoaterStorage({
                email: this.state.verification.email,
            });
            this.props.history.push("/boater/payment");
        } else if (data?.status === "error" && data.verified === false) {
            const { t } = this.props;
            this.props.addToast(t("boater_code_error"), {
                appearance: "danger",
                autoDismiss: true,
                autoDismissTimeout: 10000,
            });
        }

        this.setState({ isLoading: false });
    };

    prevSubStep = () => {
        this.setState((prevState) => ({
            ...prevState,
            verification: {
                ...prevState.verification,
                code: "",
            },
            codeIsValid: false,
            displayCodeInput: false,
        }));
    };

    render() {
        const { t, addToast } = this.props;

        return (
            <BoaterLayout step={2} loading={this.state.isLoading}>
                <div className="boater__step-container">
                    <div className="boater-step2__forms">
                        <img src={EMailIcon} height="37" alt="" />
                        {this.state.displayCodeInput ? (
                            <>
                                <p>{t("boater_email_code")}</p>
                                <form
                                    className="boater-step2__form-code"
                                    onSubmit={this.handleCodeVerif}
                                >
                                    <FormInput
                                        label={t("my_code")}
                                        type="text"
                                        name="code"
                                        id="code"
                                        appearance="secondary"
                                        placeholder="0000"
                                        inputMode="numeric"
                                        maxLength={4}
                                        labelHeight="-50px"
                                        digitsOnly={true}
                                        handle={(e) =>
                                            this.handleInputChange(
                                                e,
                                                null,
                                                "verification",
                                                () => this.checkCodeValidity(),
                                            )
                                        }
                                        value={this.state.verification.code}
                                    />
                                </form>
                                <p className="boater-step2__resend-mail">
                                    {t("email_missing")}
                                    <button
                                        type="button"
                                        onClick={(e) =>
                                            this.handleEMailDispatch(e, true)
                                        }
                                    >
                                        {t("email_resend")}
                                    </button>
                                </p>
                            </>
                        ) : (
                            <>
                                <p>{t("boater_email_input")}</p>
                                <form
                                    className="boater-step2__form-email"
                                    onSubmit={this.handleEMailDispatch}
                                >
                                    <FormInput
                                        label={t("my_email")}
                                        type="email"
                                        name="email"
                                        id="email"
                                        appearance="secondary"
                                        handle={(e) =>
                                            this.handleInputChange(
                                                e,
                                                null,
                                                "verification",
                                                () => this.checkEMailValidity(),
                                            )
                                        }
                                        value={this.state.verification.email}
                                    />
                                </form>
                                <CGUCheckbox
                                    onChange={(checked) =>
                                        this.setState({
                                            acceptCGU: checked,
                                        })
                                    }
                                    defaultChecked={this.state.acceptCGU}
                                    cguWarningTrigger={
                                        this.state.cguWarningTrigger
                                    }
                                    addToast={addToast}
                                    t={t}
                                />
                            </>
                        )}
                    </div>
                    <StepNavigation
                        prevTo={
                            this.state.displayCodeInput
                                ? null
                                : "/boater/step1-2"
                        }
                        prevHandler={
                            this.state.displayCodeInput
                                ? this.prevSubStep
                                : null
                        }
                        nextHandler={
                            this.state.displayCodeInput
                                ? this.handleCodeVerif
                                : this.handleEMailDispatch
                        }
                        nextDisabledHandler={
                            this.state.displayCodeInput
                                ? null
                                : this.handleEMailDispatch
                        }
                        nextLabel={t("Next")}
                        prevTitle={t("Previous")}
                        nextTitle={t("Next")}
                        prevDisabled={this.state.isLoading}
                        nextDisabled={
                            this.state.isLoading ||
                            (this.state.displayCodeInput
                                ? !this.state.codeIsValid
                                : !this.state.emailIsValid ||
                                  !this.state.acceptCGU)
                        }
                    />
                </div>
            </BoaterLayout>
        );
    }
}

export default withToast(
    hoistStatics(
        withTranslation()(withRouter(withBoaterStorage(BoaterProcessStep2))),
        BoaterProcessStep2,
    ),
);
